<template>
  <md-autocomplete
    :name="name"
    :id="id"
    class="autofield"
    v-model="content"
    :md-options="options"
    :md-open-on-focus="false"
    @input="handleInput"
  >
    <label class="label">{{label}}</label>
  </md-autocomplete>
</template>

<script>
export default {
  name: 'AutocompleteInput',
  props: {
    name: String,
    id: String,
    label: String,
    options: Array,
  },
  data() {
    return {
      content: this.value,
    };
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    },
  },
};
</script>

<style lang="scss">
.md-menu-content {
  margin-top: 5px;
  font-family: "Montserrat", sans-serif;
}
.md-field.autofield {
  .md-button {
    top: 26px !important;
    right: 10px !important;
  }
}
</style>

<style lang="scss">
.md-field.autofield {
  margin: 4px 0 3px;

  .md-list-item-content {
    font-family: "Montserrat", sans-serif;
  }

  &:before {
    display: none;
  }

  &:after {
    display: none;
  }

  &.md-focused,
  &.md-has-value {
    label.label {
      display: none;
    }

    .md-input {
      color: #979797;
      -webkit-text-fill-color: unset;
    }
  }

  &.md-focused {
    .md-input {
      border: 1px solid #ff5f3c;
      transition: 0.3s ease all;
      color: #ff5f3c;
      -webkit-text-fill-color: unset;
    }
  }

  .md-input {
    border: 1px solid #d8d8d8;
    border-radius: 5px;
    height: 54px;
    font-size: 16px;
    color: #979797;
    -webkit-text-fill-color: unset;
    transition: 0.3s ease all;
    padding: 0 15px;
    background: #fbfafd;
  }

  label.label {
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    color: #979797;
    top: 33px;
    left: 20px;
    background: #fbfafd;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
